import React from 'react';
import { T } from '../../../traks';

export const determinePaymentMethod = (paymentMethod) => {
    switch (paymentMethod) {
        case 'credit_card':
            return <T>Credit Card</T>;
        case 'ean':
            return <T>EAN</T>;
    }
}

export const determineOrderStatus = (paymentMethod) => {
    switch (paymentMethod) {
        case 'credit_card':
            return <T>Completed</T>;
        case 'ean':
            return <T>Created</T>;
    }
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/ThankYou/ThankYouUtils.js